<!--
    Description: Audio/Video chat for WebIM
    Create time: 2020-5-13
-->
<template>
  <Draggable v-show="emediaChatVisible">
    <div
      class="chat-media"
      :class="{
        rtcVoiceContent: streamType === 'VOICE',
        rtcVideoContent: streamType === 'VIDEO'
      }"
    >
      <div v-if="onRinging" class="mask">{{ $t('waiting for someones response', [`${contact}`]) }}</div>
      <div v-if="onRinging" class="mask">
        {{ contact  }} {{ $t('request') }} {{ streamType === 'VOICE' ? $t('audio') : $t('video') }} {{ $t('calling') }}
      </div>
      <div v-if="streamType === 'VOICE'" class="voiceCall">
        {{ $t('chat with someone', [`${contact}`]) }}
      </div>
      <video
        v-show="streamType === 'VIDEO'"
        id="localVideo"
        v-bind:class="{ localVideo: !localStream, remoteVideo: localStream }"
        autoplay
        muted
        playsinline
      />
      <video
        v-show="streamType === 'VIDEO'"
        id="remoteVideo"
        v-bind:class="{ localVideo: localStream, remoteVideo: !localStream }"
        autoplay
        playsinline
      />

      <div class="micro-section" v-show="!onRinging && streamType" @click="controlStream('audioControl')">
        <i class="chat iconfont iconaudio" v-if="isMicroOpen"></i>
        <i class="chat iconfont iconaudiostatic" v-if="!isMicroOpen"></i>
      </div>

      <i class="chat iconfont iconCall" v-show="onRinging" @click="acceptCall"></i>

      <div class="camera-section" v-show="!onRinging && streamType === 'VIDEO'" @click="controlStream('videoControl')">
        <i class="chat iconfont iconvideo" v-if="isCameraOpen"></i>
        <i class="chat iconfont iconvideo-no" v-if="!isCameraOpen"></i>
      </div>

      <div class="sound-section" v-show="!onRinging && streamType" @click="toggleMute">
        <i class="chat iconfont iconsound-filling" v-if="!isMute"></i>
        <i class="chat iconfont iconsound-Mute" v-if="isMute"></i>
      </div>

      <i class="chat iconfont iconswitch" v-show="onRinging || streamType" @click="endCall"></i>

      <i class="chat iconfont iconswitch-camera-" v-show="!onRinging && streamType === 'VIDEO'" @click="switchStream"></i>
    </div>
  </Draggable>
</template>
<script>
import { mapState } from 'vuex'
import Draggable from './Draggable'
import WebIM from '@/utils/webIM'
import i18n from '@/utils/i18n'
export default {
  name: 'media_webim',

  data() {
    return {
      caller: '',
      localStream: true,
      isMute: false,
      isCameraOpen: true,
      isMicroOpen: true
    }
  },

  computed: {
    ...mapState(['emediaChatVisible', 'sendingUser', 'streamType', 'onRinging', 'contact', 'userList'])
  },

  components: {
    Draggable
  },

  watch: {
    sendingUser: {
      handler(val) {
        if (val) {
          this.initMediaChat()
        }
      }
    }
  },

  mounted() {
    // if (this.sendingUser) {
    //   this.initMediaChat()
    // }
  },
  methods: {
    initMediaChat() {
      WebIM.rtcCall = new WebIM.WebRTC.Call({
        connection: WebIM.conn,
        mediaStreamConstaints: {
          audio: true,
          video: true
          /**
           * 修改默认摄像头，可以按照以下设置，不支持视频过程中切换
           * video:{ 'facingMode': "user" } 调用前置摄像头
           * video: { facingMode: { exact: "environment" } } 后置
           */
        },

        listener: {
          onAcceptCall: () => {
            // console.log('onAcceptCall::', 'from: ', from, 'options: ', options)
          },
          //通过streamType区分视频流和音频流，streamType: 'VOICE'(音频流)，'VIDEO'(视频流)
          onGotRemoteStream: (stream, streamType) => {
            // console.log(
            //   'onGotRemoteStream::',
            //   'stream: ',
            //   stream,
            //   'streamType: ',
            //   streamType
            // )
            // this.streamType = streamType
            this.$store.commit('setStreamType', streamType)
            document.getElementById('remoteVideo').srcObject = stream
            // this.$refs.remoteVideo.srcObject = stream
          },
          onGotLocalStream: (stream, streamType) => {
            // console.log(
            //   'onGotLocalStream::',
            //   'stream:',
            //   stream,
            //   'streamType: ',
            //   streamType
            // )
            this.$store.commit('setStreamType', streamType)
            document.getElementById('localVideo').srcObject = stream
            // this.$refs.localVideo.srcObject = stream
          },
          onRinging: caller => {
            console.log('onRinging::', 'caller:', caller)
            console.log(this.streamType)

            this.$store.commit('setRinging', true)
            this.$store.commit('toogleMediaChat')
            this.setCallerName(caller)
          },
          onTermCall: () => {
            // console.log('onTermCall::')
            // console.log('reason:', reason)
          },
          onIceConnectionStateChange: iceState => {
            console.log('onIceConnectionStateChange::', 'iceState:', iceState)
          },
          onError: e => {
            if (e.event && e.event.name === 'NotAllowedError') {
              this.$notify({
                title: i18n.t('Confirm'),
                message: i18n.t('Camera not found, please check your browser settings.'),
                type: 'warning'
              })
              WebIM.rtcCall.endCall()
              this.$store.commit('toogleMediaChat')
            } else {
              this.$notify({
                title: i18n.t('Confirm'),
                message: i18n.t(e.message),
                type: 'warning'
              })
            }
          }
        }
      })
    },

    acceptCall() {
      WebIM.rtcCall.acceptCall()
      this.$store.commit('setRinging', false)
    },

    endCall() {
      WebIM.rtcCall.endCall()
      this.$store.commit('setStreamType', '')
      this.$store.commit('toogleMediaChat')
    },

    // switch local/remote stream
    switchStream() {
      this.localStream = !this.localStream
    },

    toggleMute() {
      let muted = this.$refs.remoteVideo.muted
      if (muted) {
        this.isMute = false
        this.$refs.remoteVideo.muted = false
      } else {
        this.isMute = true
        this.$refs.remoteVideo.muted = true
      }
    },

    controlStream(type) {
      let controlType
      let to = WebIM.rtcCall.callee.split('@')[0].split('_')[1]
      if (type === 'audioControl') {
        this.isMicroOpen = !this.isMicroOpen
        controlType = this.isMicroOpen ? 0 : 1

        // this.$refs.audio.isopen = !this.$refs.audio.isopen
      } else {
        this.isCameraOpen = !this.isCameraOpen
        controlType = this.isCameraOpen ? 3 : 2

        // this.$refs.video.isopen = !this.$refs.video.isopen
      }
      WebIM.rtcCall.controlStream(controlType, to)
    },

    setCallerName(id) {
      let caller = this.userList.find(item => item.easemobAccount.toUpperCase() === id.toUpperCase())
      this.$store.commit('setContact', caller.name)
    }
  }
}
</script>
<style lang="stylus">
.chat-media {
  position: absolute;
  z-index: 9998;
  width: 350px;
  height: auto;
  top: 10%;
  left: 50%;
  overflow: hidden;
  border-radius: 5px;
  background: $color-black-65;
  transform: translate(-50%, 0);
  &.isConnected {
    background: transparent;
  }
  .micro-section, .camera-section, .sound-section {
    position: absolute;
    z-index: 9999;
    bottom: 12px;

    .iconfont {
      font-size: 30px;
      color: $color-main;
      cursor: pointer;
    }
  }

  .sound-section {
    left: 40px;
  }

  .camera-section {
    left: 80px;
  }

  .chat.iconCall {
    position: absolute;
    z-index: 9999;
    bottom: 5px;
    left: 5px;
    font-size: 30px;
    color: $color-main;
    cursor: pointer;
  }

  .chat.iconswitch {
    position: absolute;
    z-index: 9999;
    bottom: 5px;
    right: 5px;
    font-size: 30px;
    color: $color-red-f5;
    cursor: pointer;
  }

  .chat.iconswitch-camera- {
    position: absolute;
    z-index: 9999;
    top: 0;
    right: 0;
    font-size: 24px;
    color: $color-main;
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: $color-white-40;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.rtcVoiceContent {
    min-width: 350px;
    min-height: 90px;
    border-radius: 5px;
  }

  &.rtcVideoContent {
    min-width: 350px;
    height: 264px;
    margin: auto;
  }

  .remoteVideo {
    position: absolute;
    background: rgba(228, 217, 217, 0.726);
    right: 30px;
    top: 30px;
    max-height: 17%;
    max-width: 17%;
    object-fit: cover;
  }

  .localVideo {
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .mask {
    height: 100%;
    width: 100%;
    position: absolute;
    cursor: default;
    left: 0;
    background: $color-black-65;
    z-index: 3;
    color: $color-white;
    font-weight: bold;
    text-align: center;
    border-radius: 5px;
    line-height: 50px;
  }

  .voiceCall {
    height: 150px;
    background: $color-black-65;
    z-index: 3;
    border-radius: 5px;
    border-radius: 5px;
    line-height: 50px;
    color: $color-white;
    font-weight: bold;
    text-align: center;
  }
}
</style>
